import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col,Form } from "reactstrap";
import { useForm } from "react-hook-form";
import { postNotifyDriver } from "../../Services/Driver.service";
import { showAlert } from "../../Services/Shared.service";
const NotifyDriver = ({ Large, title, LargeModaltoggle,driverObj,setShowApiLoader }) => {
  const { register, handleSubmit,setValue } = useForm();
  const sendNotificationToDriver = (formValues)=>{
    const body={
      driverId:driverObj.id,
      message:formValues.message
    }
    setShowApiLoader(true);
    postNotifyDriver(body).then(result=>{
      setShowApiLoader(false);
      setValue("message","")
      showAlert('success','Sent Successfully')
      LargeModaltoggle()
    }).catch(err=>{
      setShowApiLoader(false);
      setValue("message","")
      showAlert('success','Something went wrong')
    })
  }
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={() => {
        setValue("message", "")
        LargeModaltoggle()
      }}
      size="md"
    >
      <Form onSubmit={handleSubmit(sendNotificationToDriver)}>
      <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
          <div>Enter a message to send as push notification to the driver</div>
          <textarea
            className="form-control"
            {...register("message",{
              required:{
                value:true,
                message:"Cannot send an empty message"
              }
            })}
          ></textarea>
        </Col>
        <Col xl="12" className="push-notification-footer">
          <button className="btn btn-primary" type="submit">Send</button>
        </Col>
      </Row>
      </Form>
    </CommonModal>
  );
};

export default NotifyDriver;
